(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const search_close_button = document.querySelector('header .row .searchbar-form .mobile-close-btn');
  if (search_close_button)
    search_close_button.addEventListener('click', () => {
      document.querySelector('.reset__button')?.click();
    });

  document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.js-products-container');
    const ctaBox = document.querySelector('.js-menu-cta');
    const subcategoriesWrapper = document.querySelector('.js-subcategories-container');
    const sub_categories_tabs = document.querySelector('.submenu .sub-categories-tabs-data');
    // --- Load Products ---
    function loadProducts(handle, title, url) {
      console.log('loadProducts called with:', handle, title, url);
      // Force innerTab visible — runs every time products load

      const innerTab = document.querySelector('#dynamic-products-tab');
      if (innerTab) {
        innerTab.style.setProperty('display', 'flex', 'important');
        innerTab.classList.add('active');
      }

      container.innerHTML = '<div class="loading">Loading products...</div>';
      ctaBox.classList.add('d-none');

      if (!handle) {
        container.innerHTML = '<p>No products found.</p>';
        return;
      }

      fetch(`/collections/${handle}/products.json?limit=6`)
        .then((res) => res.json())
        .then((data) => {
          // Clear loading first
          container.innerHTML = '';

          if (!data.products?.length) {
            container.innerHTML = '<p>No products found.</p>';
            ctaBox.innerHTML = '';
            ctaBox.classList.add('d-none');
            forceShowProductsTab();
            return;
          }

          // Build all HTML at once then set — never use innerHTML +=
          const html = data.products
            .map((product) => {
              const img = product.images?.[0]?.src || 'https://placehold.co/110x100?text=No+Image';
              const altText = product.title
                .toLowerCase()
                .replace(/[^a-z0-9\s-]/g, '')
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-')
                .trim();
              return `
          <a href="/products/${product.handle}" class="category-box">
            <figure><img src="${img}" alt="${altText}" width="110" height="100" loading="lazy"></figure>
            <span class="product-name">${product.title}</span>
          </a>`;
            })
            .join('');

          container.innerHTML = html;

          if (title && url) {
            ctaBox.innerHTML = `
          <p>View Our Complete ${title} Collection</p>
          <a href="${url}" class="button btn-secoundary">View All</a>
        `;
            ctaBox.classList.remove('d-none');
          }
          forceShowProductsTab();
        })
        .catch(() => {
          container.innerHTML = '<p>Failed to load products.</p>';
          forceShowProductsTab();
        });
    }

    function loadProductsold(handle, title, url) {
      console.log('Loading products for collection:', handle);
      container.innerHTML = '<div class="loading">Loading products...</div>';
      ctaBox.classList.add('d-none');

      fetch(`/collections/${handle}?view=subcategories.products`)
        .then((res) => res.text())
        .then((html) => {
          container.innerHTML = html;

          if (title && url) {
            ctaBox.innerHTML = `
              <p>View Our Complete ${title} Collection</p>
              <a href="${url}" class="button btn-secoundary">View All</a>
            `;
            ctaBox.classList.remove('d-none');
          }
        })
        .catch(() => {
          container.innerHTML = '<p>Failed to load products.</p>';
        });
    }

    // --- Load Subcategories ---
    // --- Load Subcategories ---
    function loadSubcategories(parentHandle, ref) {
      subcategoriesWrapper.innerHTML = '';
      container.innerHTML = '<div class="loading">Loading products...</div>';
      ctaBox.classList.add('d-none');

      // // ✅ Always ensure products panel is visible on every load
      // if (sub_categories_tabs) {
      //   sub_categories_tabs.classList.add('active');
      //   sub_categories_tabs.style.display = '';
      // }

      // // ✅ Also reset inner-tab visibility
      // const innerTab = document.querySelector('#dynamic-products-tab');
      // if (innerTab) {
      //   innerTab.style.setProperty('display', 'flex', 'important');
      //   innerTab.classList.add('active');
      // }

      if (!window.shopMenuData || !Array.isArray(window.shopMenuData)) {
        subcategoriesWrapper.innerHTML = '<p>Menu data not loaded.</p>';
        return;
      }

      const menuItem = window.shopMenuData.find((item) => item.index === parseInt(ref));

      if (!menuItem) {
        subcategoriesWrapper.innerHTML = '<p>No categories found.</p>';
        return;
      }

      if (menuItem.children.length > 0) {
        const items = menuItem.children
          .map((child, i) => {
            if (child.handle) {
              return `
            <li>
              
               <a href="${child.url}"
                class=" ${i === 0 ? 'active' : ''}"
                data-tab="${child.handle}"
                data-collection-handle="${child.handle}"
              >
                ${child.title}
                <button class="inner-tab-trigger" >
                  <span class="sr-only">Open menu</span>
                  <i class="icon-arrow-right"></i>
                </button>
              </a>
            </li>`;
            } else {
              return `
            <li>
              <a href="${child.url}" class="inner-normal-link">
                ${child.title}
              </a>
            </li>`;
            }
          })
          .join('');
        subcategoriesWrapper.innerHTML = `<ul class="inner-categories-list">${items}</ul>`;
      } else {
        // No children — show parent as single tab
        subcategoriesWrapper.innerHTML = `
      <ul class="inner-categories-list">
        <li>
          
          <a  href="${menuItem.url}"
            class="active"
            data-collection-handle="${menuItem.handle}"
          >
            ${menuItem.title}
            <button class="inner-tab-trigger" >
              <span class="sr-only">Open menu</span>
              <i class="icon-arrow-right"></i>
            </button>
          </a>
        </li>
      </ul>`;

        loadProducts(menuItem.handle, menuItem.title, menuItem.url);

        // const singleLink = subcategoriesWrapper.querySelector('.inner-tab-trigger');
        // if (singleLink) {
        //   singleLink.addEventListener('click', function (e) {
        //     e.preventDefault();
        //     window.location.href = menuItem.url;
        //   });
        // }
        return;
      }

      // Bind clicks — use data from menuItem.children directly
      subcategoriesWrapper.querySelectorAll('.inner-tab-trigger').forEach((trigger) => {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          subcategoriesWrapper
            .querySelectorAll('.inner-tab-trigger')
            .forEach((el) => el.parentElement.classList.remove('active'));
          this.parentElement.classList.add('active');

          // if (sub_categories_tabs) {
          //   sub_categories_tabs.classList.add('active');
          //   sub_categories_tabs.style.display = '';
          // }

          // // ✅ Also force show the inner-tab — it gets display:none from somewhere
          // const innerTab = document.querySelector('#dynamic-products-tab');
          // if (innerTab) {
          //   innerTab.style.setProperty('display', 'flex', 'important');
          //   innerTab.classList.add('active');
          // }

          loadProducts(
            this.parentElement.dataset.collectionHandle,
            this.parentElement.textContent.trim(),
            this.parentElement.getAttribute('href')
          );
        });
      });

      // Auto-load first child using data — not DOM href
      const firstChild = menuItem.children.find((c) => c.handle);
      if (firstChild) {
        loadProducts(firstChild.handle, firstChild.title, firstChild.url);
      } else {
        container.innerHTML = '<p>No subcategories found.</p>';
        ctaBox.classList.add('d-none');
      }
    }

    // --- Parent category click ---
    document.querySelectorAll('.megamenu-tab-trigger').forEach((trigger) => {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        let collection = this.parentElement.dataset.collection;
        let ref = this.parentElement.dataset.ref;

        loadSubcategories(collection, ref); // pass ref
      });
    });

    // --- Init first parent ---
    const first_category_button = document.querySelector('.megamenu-tab-trigger');
    if (first_category_button) {
      let collection = first_category_button.parentElement.dataset.collection;
      let ref = first_category_button.parentElement.dataset.ref;
      loadSubcategories(collection, ref);
    }
  });
  function forceShowProductsTab() {
    // requestAnimationFrame(() => {
    //   const innerTab = document.querySelector('#dynamic-products-tab');
    //   const sub_categories_tabs = document.querySelector('.submenu .sub-categories-tabs-data');
    //   if (innerTab) {
    //     innerTab.removeAttribute('style'); // wipe any inline display:none
    //     innerTab.classList.add('active');
    //   }
    //   if (sub_categories_tabs) {
    //     sub_categories_tabs.removeAttribute('style');
    //     sub_categories_tabs.classList.add('active');
    //   }
    // });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          // Re-init swiper after content load
          initRelatedProductsSwiper();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  function initRelatedProductsSwiper() {
    const sliderEl = document.querySelector('.product-slider.swiper');
    if (!sliderEl || typeof Swiper === 'undefined') return;

    if (sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }

    new Swiper(sliderEl, {
      slidesPerView: 1.3,
      spaceBetween: 10,
      //watchOverflow: true,     // disables nav if not enough slides
      breakpoints: {
        480: {
          slidesPerView: 2.1,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1023: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
        1200: {
          slidesPerView: 5,
          spaceBetween: 15,
        },
        1400: {
          spaceBetween: 20,
          slidesPerView: 5,
        },
        1600: {
          slidesPerView: 6,
          spaceBetween: 20,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-product-custom"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          // Re-init swiper after content load
          initRelatedProductsSwiper();
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  function initRelatedProductsSwiper() {
  const sliderEl = document.querySelector('.product-slider.swiper');
  if (!sliderEl || typeof Swiper === 'undefined') return;

  if (sliderEl.swiper) {
    sliderEl.swiper.destroy(true, true);
  }

  new Swiper(sliderEl, {
    slidesPerView: 1.3,
    spaceBetween: 10,
    breakpoints:{
        480: {
            slidesPerView: 2.1,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 10,
        },
        1023: {
            slidesPerView: 4,
            spaceBetween: 15,
        },
        1200: {
            slidesPerView: 5,
            spaceBetween: 15,
        },
        1400:{
            spaceBetween: 20,
            slidesPerView: 5,
        },
        1600: {
            slidesPerView: 6,
            spaceBetween: 20,
        }
    },  
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
